<template>
  <v-dialog v-model="dialog" overlay-opacity="0.75" persistent max-width="500">
    <v-card relative class="backgroundW">
      <v-btn
        absolute
        class="mt-2"
        :style="$vuetify.rtl == true ? 'left: 0' : 'right: 0'"
        small
        fab
        color="grey lighten-1"
        text
        @click="closeDialog"
      >
        <v-icon color="grey lighten-1">mdi-close</v-icon>
      </v-btn>
      <v-card-title class="text-h6 font-weight-bold">
        <v-icon size="25" class="mx-2">mdi-plus</v-icon>
        <div class="text-h6 font-weight-bold">
          {{
            entityName
              ? $t("add") + " " + $t(entityName)
              : $t("add") | capitalize
          }}
        </div>
      </v-card-title>

      <v-col cols="12" sm="12" class="px-7" :key="dialogKey">
        <v-row align="center">
          <GenericInput
            type="text"
            :dense="true"
            :value="form.name"
            @input="form.name = $event"
            label="name"
            :required="true"
            :isLoading="false"
            :cols="[6, 6, 6]"
          />
          <GenericInput
            type="text"
            :dense="true"
            v-if="enablePhone"
            :value="form.phone"
            @input="form.phone = $event"
            label="phone"
            :required="false"
            :isLoading="false"
            :cols="[6, 6, 6]"
          />
          <GenericInput
            type="select"
            :dense="true"
            :lookups="booking_options"
            v-if="enableBookingOption"
            :value="form.booking_option"
            @input="form.booking_option = $event"
            label="booking option"
            :multi="false"
            :required="false"
            selected_label="name"
            selected_prop="id"
            :disabled="false"
            :cols="[6, 6, 6]"
          ></GenericInput>

          <GenericInput
            v-if="form.booking_option == 2"
            type="text"
            :dense="true"
            :value="form.ads_name"
            @input="form.ads_name = $event"
            label="advertising campaign name"
            :required="false"
            :isLoading="false"
            :cols="[6, 6, 6]"
          />
        </v-row>
      </v-col>

      <v-col cols="12" class="pa-7">
        <v-row justify="end">
          <v-col cols="auto">
            <v-btn depressed color="error" text plain @click="closeDialog">
              {{ $t("close") }}</v-btn
            >
          </v-col>
          <v-col cols="auto">
            <v-btn
              depressed
              color="success"
              :loading="isLoading"
              :disabled="!form.name"
              min-width="110"
              @click="save"
            >
              {{ $t("add") }}</v-btn
            >
          </v-col>
        </v-row>
      </v-col>
    </v-card>
  </v-dialog>
</template>

<style scoped lang="scss"></style>

<script>
import GenericInput from "@/components/GenericInput.vue";

export default {
  name: "AddLockupsDialog",
  props: {
    closeMethod: { type: Function },
    saveMethod: { type: Function },
    dialog: { default: false },
    enablePhone: { default: false },
    postKey: { default: null },
    sendAsRequest: { default: true },
    entityName: { default: null },
    endPoint: { default: null },
    dataKey: { default: "id" },
    callBackMethod: { type: Function, default: null },
    enableBookingOption: { default: false },
  },
  computed: {
    booking_options() {
      return [
        { id: 1, name: this.$t("New client") },
        { id: 2, name: this.$t("Advertising campaign") },
      ];
    },
  },
  watch: {
    dialog() {
      this.dialogKey = this.dialogKey + 1;
    },
  },
  data: () => ({
    isLoading: false,
    dialogKey: 1,
    form: {
      name: null,
      phone: null,
      booking_option: 1,
      ads_name: null,
      notes: null,
    },
  }),
  methods: {
    closeDialog() {
      this.dialogKey = this.dialogKey + 1;
      this.closeMethod();
    },
    save() {
      if (this.sendAsRequest == true) {
        this.isLoading = true;
        var requestBody = null;
        if (this.postKey) {
          requestBody = {
            [this.postKey]: [
              {
                name: this.form.name,
                phone: this.form.phone,
                booking_option: this.form.booking_option,
                ads_name: this.form.ads_name,
                notes: this.form.notes,
              },
            ],
          };
        } else {
          requestBody = {
            name: this.form.name,
          };
        }

        if (this.enablePhone) {
          requestBody.phone = this.form.phone;
        }
        if (this.enableBookingOption) {
          requestBody.booking_option = this.form.booking_option;
        }
        if (this.enableBookingOption &&this.form.booking_option == 2) {
          requestBody.ads_name = this.form.ads_name;
        }

        this.$api.POST_METHOD(`${this.endPoint}`, requestBody).then((res) => {
          this.isLoading = false;
          if (res.check) {
            res.data.name = this.form.name || null;
            res.data.phone = this.form.phone;
            res.data.booking_option = this.form.booking_option;
            res.data.ads_name = this.form.ads_name;
            res.data.notes = this.form.notes;
            this.saveMethod(res.data);
            this.form = {
              name: null,
              booking_option: null,
              ads_name: null,
              phone: null,
              notes: null,
            };
            this.dialogKey = this.dialogKey + 1;
            this.callBackMethod(res.data);
          }
        });
      } else {
        this.form.name = this.form.name || null;
        this.saveMethod(this.form);
        this.form = {
          name: null,
          booking_option: null,
          ads_name: null,
          phone: null,
          notes: null,
        };
        this.dialogKey = this.dialogKey + 1;
      }
    },
  },
  mounted() {},
  components: { GenericInput },
};
</script>
